<template>
  <div class="event-list">
    <p class="date-title">
      {{ dateStr }}
      <template v-if="infos.courseQuantity">
        （{{ infos.courseQuantity }}节课）
      </template>
    </p>
    <template v-if="infos.courseArrangeRecordVos">
      <div
        class="list"
        v-for="(item,idx) of infos.courseArrangeRecordVos"
        :class="{
          'is-stop': item.courseStatus === 2,
          'is-finished': item.courseStatus === 1,
        }"
        :key="item.id + '' + item.studentId + idx"
      >
        <div class="l1">
          <div class="l1-l">
            {{ item.startTime | formatDatetime("hh:mm") }}～
            {{ item.endTime | formatDatetime("hh:mm") }}
          </div>
          <div class="l1-r">
            <div class=" van-ellipsis">{{ item.studentName }}</div>
          </div>
        </div>
        <div class="l2">

          <span v-if="item.courseArrangePlanType === 0">{{ item.className }}</span> 
          <span v-else><span v-if="item.curriculumName">{{ item.curriculumName }}</span></span>&nbsp;
          <span class="audition" v-if="item.identity === 2">试听</span>
        </div>
        <div class="l2">
          <div class="l2-item" v-if="item.courseArrangeTeacherVoList && item.courseArrangeTeacherVoList.length">
            <div class="van-ellipsis">
              <van-icon name="laoshi1" class-prefix="vxs-icon" />{{
                item.courseArrangeTeacherVoList | getTeacher
              }}
            </div>
          </div>
          <div class="l2-item" v-if="item.classRoomName">
            <div class="van-ellipsis">
              <van-icon name="jiaoshi" class-prefix="vxs-icon" />
              {{ item.classRoomName }}
            </div>
          </div>
        </div>
        
        <div class="l2 noline cct" v-if="item.courseContent">
          <div>上课内容：</div>
          <div class="ccon van-multi-ellipsis--l2">{{item.courseContent}}</div>
          <div class="ccbtn" style="color:var(--c1)"  @click="showContent(item.courseContent)">查看</div>
        </div>
        
        <div class="l2 noline" v-if="item.courseStatus == 2">
          已取消
          <span @click="showStopReason(item.reason)" class="show-stop-reason">
            查看原因<van-icon name="arrow" />
          </span>
        </div>
        <svg
            v-if="item.haveLeave"
            class="end-icon"
            aria-hidden="true"
          >
            <use
              xlink:href="#vxm-icon-yiqingjia"
            ></use>
          </svg>
      </div>
    </template>

    <div class="list" v-if="infos.isToDay && !infos.list.length">
      没有课程安排哦～
    </div>
  </div>
</template>

<script>
export default {
  name: "EventList",
  props: {
    infos: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data: () => ({
    day: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
  }),
  computed: {
    dateStr () {
      let  { infos } = this;
      if (!infos.date && !new Date(infos.date)) return '--';
      let infosDate = infos.date; 
      let currentDateStr = app.tool.date.formatDatetime(new Date(), 'yyyy-MM-dd');
      let infosDateStr = app.tool.date.formatDatetime(new Date(infosDate), 'yyyy-MM-dd');
      let dayStr = this.day[new Date(infos.date).getDay()]
      if ( currentDateStr === infosDateStr ) {
        return '今日/' + dayStr + ' ';
      }
      return app.tool.date.formatDatetime(new Date(infosDate), 'yyyy年MM月dd日') + '/' + dayStr + ' ';
    },
  },
  filters: {
    getTeacher(teachers) {
      let tcs = teachers.filter(v=>v.teacherRule === 0).map(v=>v.teacherName);
      if (tcs.length) {
        return tcs.join("、");
      } else {
        return `未设置`
      }
    }
  },
  methods: {
    showStopReason (message = '暂无停课原因。') {
      this.$dialog.alert({
        title: '取消原因',
        message,
      })
    },
    showContent(msg) {
      vant.Dialog.alert({
        title: '上课内容',
        message: msg,
        messageAlign: 'left'
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.event-list {
  padding: 0 calc(var(--gap) * 16);
  .date-title {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: calc(var(--gap) * 8) 0;
    padding: 0 calc(var(--gap) * 16);
    box-sizing: border-box;
    height: calc(var(--w) * 26);
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
    color: var(--g6);
  }
  .list {
    position: relative;
    padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
    margin-bottom: calc(var(--gap) * 12);
    color: var(--g6);
    font-size: var(--fs-md);
    background-color: var(--white);
    overflow: hidden;
    .l1 {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: calc(var(--w) * 24);
      .l1-l {
        color: var(--g8);
        flex: 1;
        margin-right: calc(var(--gap) * 16);
        white-space: nowrap;
        font-size: calc(var(--fs-ex2) * 1.2);
        line-height:calc(var(--lh-ex2) * 1.2);
      }
      .l1-r {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        overflow: hidden;
      }
    }
    .l2 {
      margin-top: calc(var(--gap) * 8);
      display: flex;
      .l2-item {
        display: flex;
        max-width: 50%;
        justify-content: center;
        align-items: center;
        &:first-child{          
          margin-right: calc(var(--gap) * 10);
        }
        >.van-ellipsis>i {
          margin-right: calc(var(--gap) * 4);
        }
      }
      >span.show-stop-reason{
        margin-left: calc(var(--gap) * 5);
        display: flex;
        align-items: center;
        color: #EE0A24;
      }
      span.audition{
        height: var(--lh-lg);
        line-height:var(--lh-lg);
        font-size:var(--fs-sm);
        padding:0 calc(var(--gap) * 6);
        color: var(--c1);
        background: rgba(255, 116, 55, 0.2);
        border-radius: calc(var(--w) * 2);
        border-radius: var(--radius-sm);
        white-space: nowrap;
      }
    }
    &.is-stop{
      .l1-l,
      .l2:not(:last-child),
      .l1-r{
        color: var(--g6);
        text-decoration: line-through;
        &.noline {
          text-decoration: none;
        }
      }
    }
    &.is-finished{
      .l1-l{
        color: var(--g6);
      }
    }
    >div{
      position: relative;
      z-index: 2;
    }
    .end-icon{
      position: absolute;
      width: calc(var(--w) * 48);
      height: calc(var(--w) * 48);
      bottom: calc(var(--w) * -10);
      right: calc(var(--w) * -6);
      z-index: 1;
    }
  }
  .cct {
    display: flex;
    .ccon {
      flex: 1;
    }
    .ccbtn {
      display: flex;
      align-items: flex-end;
    }
  }
}
</style>
